import { render, staticRenderFns } from "./isLoadingTip.vue?vue&type=template&id=8c07cfac&scoped=true&"
import script from "./isLoadingTip.vue?vue&type=script&lang=js&"
export * from "./isLoadingTip.vue?vue&type=script&lang=js&"
import style0 from "./isLoadingTip.vue?vue&type=style&index=0&id=8c07cfac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c07cfac",
  null
  
)

export default component.exports